import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { FakeLink } from '@change-corgi/design-system-legacy/components/actions';

type RemoveOptionProps = {
	onDelete: () => void;
};

export function RemoveOption({ onDelete }: RemoveOptionProps): JSX.Element {
	return (
		<FakeLink
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
				onDelete();
			}}
			data-testid="movement-remove-petition-button"
			data-qa="movement-remove-petition-button"
			sx={{ fontSize: 12 }}
		>
			<Translate value="corgi.movement.show.petition_card.remove_petition_link" />
		</FakeLink>
	);
}
